export const getFooterStyles = {
	width: '100%',
	backgroundColor: 'backgrounds.darkTwo',
};
export const wrapperStyles = {
	display: 'flex',
	flexFlow: { xs: 'column', md: 'row nowrap' },
	justifyContent: 'space-between',
	color: 'neutrals.white',
	margin: '0 auto',
	paddingY: '2.5rem',
	paddingX: { xs: '2rem', md: '5%' },
	pb: '3rem',
};

export const getGroupWrapperStyles = (isMobile: boolean) => ({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: isMobile ? 'wrap' : 'nowrap',
	rowGap: '2rem',
	columnGap: '2rem',
	justifyContent: 'space-between',
});

export const getGroupItemStyles = (isMobile: boolean) => ({
	display: 'flex',
	flexDirection: 'column',
	flex: '1 1 auto',
	borderLeft: isMobile ? '' : '1px solid white',
	paddingLeft: isMobile ? '' : '1.5rem',
	paddingRight: isMobile ? '' : '1.5rem',
	gap: isMobile ? '1rem' : '',

	'&:last-child': {
		paddingRight: '0',
		flex: isMobile ? '1 0 100%' : '0 1 33%',
		alignItems: isMobile ? 'center' : '',
		gap: isMobile ? '1rem' : '',
	},
});

export const getNavLinkStyles = () => ({
	justifyContent: 'flex-start',
	lineHeight: '2rem',
	fontWeight: 600,
	fontSize: '1rem',
});

export const getNavTitleStyles = () => ({
	fontSize: '1.13rem',
});

export const getFooterConnectBlockStyles = (isMobile: boolean) => ({
	display: isMobile ? 'flex' : 'block',
	flexFlow: 'row nowrap',
	alignItems: isMobile ? 'center' : '',
	width: '100%',
	justifyContent: 'center',
	gap: '2rem',
});

export const getSocialImageStyle = {
	width: '1.25rem',
	height: '1.25rem',
};

export const policyGroupStyle = {
	width: '100%',
	display: { xs: 'grid', md: 'flex' },
	flexFlow: { xs: '', md: 'column' },
	alignItems: 'flex-start',
	gap: { xs: '.5rem', md: '0' },
	gridTemplateColumns: { xs: `repeat(2, 1fr)`, md: '' },
	gridAutoRows: { xs: 'auto', md: '' },
};
